import React from 'react';

import ClockIcon from '@atlaskit/icon/core/clock';

const RelatedLinksActionIcon = (): React.JSX.Element => (
	<ClockIcon color="currentColor" spacing="spacious" label="View related links..." />
);

export default RelatedLinksActionIcon;
